import { render, staticRenderFns } from "./StokAktarComponent.vue?vue&type=template&id=227aa744"
import script from "./StokAktarComponent.vue?vue&type=script&lang=js"
export * from "./StokAktarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports